import React from "react";
import {observer} from "mobx-react";
import {
    IPsoFamilyAgreementViewModel
} from "../../../../../../services/booking/models/pso/agreements/families/pso-family-agreement.view-model.interface";
import {StringFieldEditorComponent} from "../../../../../forms/string-field/string-field-editor.component";
import { FullGridLineBox } from "../../../common/boxes/pso-agreement.boxes";

export const SpecificDegreeOfKinshipFullNameComponent: React.FC<{familyAgreement: IPsoFamilyAgreementViewModel}> = observer((props) => {


    if(props.familyAgreement.fields.specificDegreeOfKinshipFullName.isHidden) {
        return null;
    }

    return (
        <FullGridLineBox>
            <StringFieldEditorComponent field={props.familyAgreement.fields.specificDegreeOfKinshipFullName}
                                        placeholder={props.familyAgreement.fields.specificDegreeOfKinshipFullName.fieldName}
                                        hideLabel={true}/>
        </FullGridLineBox>
    )
})